import {Routes} from '@angular/router';
import {LoginPaths} from './login-paths.enum';
import {LoginFormComponent} from './login-form/login-form.component';
import {RecoveryPasswordFormComponent} from './recovery-password-form/recovery-password-form.component';
import {ResetPasswordFormComponent} from './reset-password-form/reset-password-form.component';
import {Oauth2sApiService} from '../../../projects/api/src/oauth2/oauth2s-api.service';
import {LoginFormBackgroundComponent} from './login-form-background/login-form-background.component';
import {TwofactorFormComponent} from './twofactor-form/twofactor-form.component';

export const loginRoutes: Routes = [
  {
    path: '',
    component: LoginFormBackgroundComponent,
    children: [
      {
        path: LoginPaths.loginForm, component: LoginFormComponent,
        resolve: {
          oauth2list: Oauth2sApiService
        }
      },
      {
        path: LoginPaths.twoFactorForm, component: TwofactorFormComponent
      },
      {
        path: LoginPaths.loginRecoveryPassword, component: RecoveryPasswordFormComponent
      },
      {
        path: LoginPaths.loginResetPassword, component: ResetPasswordFormComponent,
        children: []
      }
    ]
  }
];
